document.addEventListener('DOMContentLoaded', () => {
  let observer;

  const initializeEventListeners = () => {
    const stickyBuyButton = document.querySelector('button.sticky-buy-button');
    const priceContainer = document.querySelector('.price__container');

    if (stickyBuyButton && priceContainer) {
      // Remove any existing click listeners to avoid duplicates
      stickyBuyButton.removeEventListener('click', handleStickyButtonClick);

      // Add the click listener
      stickyBuyButton.addEventListener('click', handleStickyButtonClick);
    }
  };

 const handleStickyButtonClick = () => {
  const priceContainer = document.querySelector('.price__container');
  const stickyHeader = document.querySelector('sticky-header'); 
  const isMobile = window.innerWidth <= 768;

  if (priceContainer) {
    // Calculate the offset based on header height
    const headerHeight = isMobile ? 10 : stickyHeader ? stickyHeader.offsetHeight : 0;

    // Get the position of the priceContainer
    const targetPosition = priceContainer.getBoundingClientRect().top + window.scrollY;

    // Adjust scrolling based on whether it's scrolling up or down
    const currentScroll = window.scrollY;
    const scrollOptions = {
      behavior: 'smooth',
      top: targetPosition - headerHeight, // Apply offset when scrolling
    };

    // Determine scrolling direction
    if (currentScroll > targetPosition) {
      // Scrolling back up
      scrollOptions.top = targetPosition - headerHeight; // Apply header offset
    } else {
      // Scrolling down
      scrollOptions.top = targetPosition; // No offset
    }

    // Perform the scroll
    window.scrollTo(scrollOptions);
  }
};

 const initializeObserver = () => {
  const topBuyButton = document.querySelector('button[name="add"]');
  const stickyBuyButton = document.querySelector('button.sticky-buy-button');
  const stickyHeader = document.querySelector('sticky-header');
  const isMobile = window.innerWidth <= 768; // Define breakpoint for mobile

  if (stickyBuyButton && topBuyButton) {
    // Calculate dynamic rootMargin based on sticky header height
    const headerHeight = isMobile ? 60 : stickyHeader ? stickyHeader.offsetHeight : 0;
    const adjustedRootMargin = `-${headerHeight + 30}px 0px 0px`;

    const options = {
      threshold: 1,
      root: null,
      rootMargin: adjustedRootMargin,
    };

    const callback = (entries) => {
      if (entries?.[0].isIntersecting) {
        stickyBuyButton.style.display = 'none';
      } else {
        stickyBuyButton.style.display = 'block';
      }
    };

    // Disconnect the previous observer if it exists
    if (observer) {
      observer.disconnect();
    }

    // Create a new observer and observe the topBuyButton
    observer = new IntersectionObserver(callback, options);
    observer.observe(topBuyButton);
  }
};


  // Initialize event listeners and observer on page load
  initializeEventListeners();
  initializeObserver();

  // Reinitialize everything on variant change
  document.addEventListener('variant:change', () => {
    initializeEventListeners();
    initializeObserver();
  });
});
